import React from "react";
import PropTypes from "prop-types";
import Text, {
  TEXT_FONT_WEIGHT,
  TEXT_KIND,
  TEXT_ALIGN,
  TEXT_SIZE,
} from "@/bit/components/components.text";
import { createCmsLabelProps } from "./utils";
import { LABEL_SHAPES, LABEL_TYPES, LABEL_STYLES } from "./enums";

/**
 * Elemento de interfaz que muestra texto para describir o identificar otros componentes. No es interactivo, pero proporciona información útil al usuario.
 */
const Label = (props) => {
  const { text, textSize, color, opacity, cyData, cmsHandler, className } =
    createCmsLabelProps(props);

  if (!text) {
    return null;
  }

  return (
    <div
      className={className}
      onClick={
        cmsHandler
          ? () => cmsHandler({ ...props, name: "cms-block.label" })
          : null
      }
    >
      <Text
        text={text}
        color={color}
        opacity={opacity}
        kind={TEXT_KIND.SPAN}
        size={textSize}
        fontType={TEXT_FONT_WEIGHT.REGULAR}
        align={TEXT_ALIGN.CENTER}
        cyData={cyData}
        cmsHandler={cmsHandler}
      />

      <style jsx>{`@import "styles/colors.scss";

.cms-label {
  width: fit-content;
  min-height: 22px;

  &.promocion {
    background-color: $color--red_high;
  }
  &.promocion-inverse {
    background-color: $color--movistar_white;
  }
  &.informacion, &.recomendado {
    background-color: $color--movistar_black;
  }
  &.informacion-inverse {
    background-color: $color--movistar_white;
  }
  &.active {
    background-color: $color--blue_200;
  }
  &.active-inverse {
    background-color: $color--movistar_white;
  }
  &.inactive {
    background-color: $color--grey1;
  }
  &.inactive-inverse {
    background-color: $color--movistar_white;
  }
  &.success, &.contratado {
    background-color: $color--green_200;
  }
  &.success-inverse {
    background-color: $color--movistar_white;
  }
  &.warning {
    background-color: $color--yellow_600;
  }
  &.warning-inverse {
    background-color: $color--movistar_white;
  }
  &.error {
    background-color: $color--red_high;
  }
  &.error-inverse {
    background-color: $color--movistar_white;
  }

  &.square {
    border-radius: 0px;
    padding: 2px 6px;
  }
  &.tears {
    border-radius: 16px 0px;
    padding: 2px 16px;
    position: absolute;
    top: 0;
    left: 0;
  }
  &.roof {
    border-radius: 16px 16px 0px 0px;
    padding: 2px 16px;
    width: 100%;
  }
}
 `}</style>
    </div>
  );
};

Label.propTypes = {
  /**
   * {
   *  "info": "Define la forma del label y puede ser uno de los siguientes valores: 'square','tears' o 'roof'",
   *  "kind": "both",
   *  "beautifulName": "Shape",
   *  "values": "./enums.js:LABEL_SHAPES"
   * }
   */
  shape: PropTypes.string,

  /**
   * {
   *  "info": "Define el tipo de label y puede ser uno de los siguientes valores: 'promocion', 'informacion', 'active', 'inactive','success', 'warning','error', 'recomendado', 'contratado'",
   *  "kind": "both",
   *  "beautifulName": "Type",
   *  "values": "./enums.js:LABEL_TYPES"
   * }
   */
  type: PropTypes.string,

  /**
   * {
   *  "info": "Texto del label",
   *  "kind": "both",
   *  "beautifulName": "Text"
   * }
   */
  text: PropTypes.string,

  /**
   * {
   *  "info": "Tamaño del texto, puede ser 'Title', 'Display' o 'Caption' (cada uno con sus niveles).",
   *  "kind": "dev",
   *  "beautifulName": "Tamaño",
   *  "values": "./enums.js:TEXT_SIZE_ENUMS"
   * }
   */
  textSize: PropTypes.string,
};

Label.defaultProps = {
  shape: LABEL_SHAPES.SQUARE,
  type: LABEL_TYPES.PROMOCION,
};

export default Label;
export { LABEL_SHAPES, LABEL_TYPES, LABEL_STYLES };
